<template>

    <div>

        <transition name="modal">
            <manager-modal
                :manager_id="modal_manager_id"
                @close="() => {
                    modal_manager_id = null
                    refresh()
                }"
                v-if="modal_manager_id"
                @refresh="refresh()"
            />
        </transition>

        <div class="row mb-4">

            <div class="col-24 col-md-6">
                <input type="text"
                       class="form-control new-list-group-field"
                       placeholder="Sök namn, e-postadress mm"
                       v-model="settings.query.text"
                >
            </div>

            <div class="col-24 col-md-18 d-flex justify-content-end">
                <button class="btn btn-primary btn-sm mr-2" @click="createManager()">Lägg till konto
                    <div class="tooltip-label">Lägg till ett konto.</div>
                </button>
            </div>

        </div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">
                <div class="row g-3" :class="{'inactive-stroke': props.item.disabled_at}">
                    <div class="col d-none d-md-flex col-md-1">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" :value="props.item.id" v-model="bulk_selected">
                        </div>
                    </div>
                    <div class="col d-none d-md-flex col-md-1">
                        <span>{{ props.item.id }}</span>
                    </div>
                    <div class="col col-12 col-md-4">
                        <span>{{ props.item.name }} <span class="badge" style="text-decoration: none;" v-if="props.item.disabled_at">Inaktivt</span></span>
                    </div>
                    <div class="col d-none d-md-flex col-md-6">
                        <span class="break-all">{{ props.item.email }}</span>
                    </div>
                    <div class="col d-none d-md-flex col-md-4">
                        <span v-if="props.item.type == 'regular'">Användare</span>
                        <span v-else>Administratör</span>
                    </div>
                    <div class="col d-none d-md-flex col-md-3">
                        <span>{{ props.item.created_at }}</span>
                    </div>
                    <div class="col col-12 col-md-5 d-flex justify-content-end">

                        <span v-if="props.item.disabled_at">
                            <button-disable-account btnClass="btn-sm" :manager="props.item" @success="refresh()">
                                Återaktivera
                                <div class="tooltip-label">Återaktivera inloggningen</div>
                            </button-disable-account>
                        </span>
                        <span v-else>
                            <button-restore-password btn-class="btn-sm btn-info" :manager="props.item">
                                <img src="/images/admin/icon-renew.svg">
                                <div class="tooltip-label">Skicka återställningslänk för lösenord</div>
                            </button-restore-password>
                            <button-disable-account btn-class="btn-sm" :manager="props.item" @success="refresh()">
                                <img src="/images/admin/icon-deactivate.svg">
                                <div class="tooltip-label">Inaktivera kontot tillfälligt</div>
                            </button-disable-account>
                            <button-delete-account btn-class="btn-sm" :manager="props.item" @success="refresh()">
                                <img src="/images/admin/icon-trash.svg">
                                <div class="tooltip-label">Radera kontot helt</div>
                            </button-delete-account>
                            <button class="btn btn-primary btn-sm" @click="modal_manager_id = props.item.id">Hantera
                                <div class="tooltip-label">Redigera namn, e-postadress eller behörighet</div>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </list>
    </div>

</template>

<script>
import managerModal from '../managers/modal.vue'
import buttonRestorePassword from '../managers/button-restore-password'
import buttonDisableAccount from '../managers/button-disable-account'
import buttonDeleteAccount from '../managers/button-delete-account'

import lister from '../../../../shared/mixins/lister'
import axios from 'axios'

export default {

    mixins: [
        lister
    ],

    components: {
        managerModal,
        buttonRestorePassword,
        buttonDisableAccount,
        buttonDeleteAccount
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            modal_manager_id: null,

            settings: {
                url: '/companies/' + this.company_id + '/managers/list',
                query: {
                    text: ''
                },
                columns: [
                    { column: 'check', name: '', class: 'col d-none d-md-flex col-md-1', sortable: false },
                    { column: 'id', name: 'ID', class: 'col d-none d-md-flex col-md-1', sortable: true, default: true },
                    { column: 'name', name: 'Namn', class: 'col col-18 col-md-4', sortable: true },
                    { column: 'email', name: 'E-postadress', class: 'col d-none d-md-flex col-md-6', sortable: true },
                    { column: 'type', name: 'Behörighet', class: 'col d-none d-md-flex col-md-4', sortable: true },
                    { column: 'created_at', name: 'Konto skapat', class: 'col d-none d-md-flex col-md-3', sortable: true }
                ],
                bulk_actions: [
                    { event: 'bulkDisableAccounts', label: 'Inaktivera konton' },
                    { event: 'bulkDeleteAccounts', label: 'Radera konton' }
                ]
            }
        }
    },

    methods: {
        createManager () {
            axios.post('/companies/' + this.company_id + '/managers')
                .then(response => {
                    this.modal_manager_id = response.data.manager_id
                })
        },
        bulkDisableAccounts () {
            if (!confirm('Vill du verkligen inaktivera ' + this.bulk_selected.length + ' konton? Detta kan inte ångras.')) {
                return
            }

            axios.post(
                '/managers/bulkDisableAccounts',
                { manager_ids: this.bulk_selected }
            ).then(result => {
                bus.$emit(
                    'notify',
                    this.bulk_selected.length + ' konton har blivit inaktiverade'
                )
                this.refresh()
                this.bulk_selected = []
            })
        },
        bulkDeleteAccounts () {
            if (!confirm('Vill du verkligen radera ' + this.bulk_selected.length + ' konton?')) {
                return
            }

            axios.post(
                '/managers/bulkDeleteAccounts',
                { manager_ids: this.bulk_selected }
            ).then(result => {
                bus.$emit(
                    'notify',
                    this.bulk_selected.length + ' konton har blivit raderade'
                )
                this.refresh()
                this.bulk_selected = []
            })
        }
    }

}
</script>
